module.exports = __webpack_public_path__ + "static/media/start-scheduling.b1961e69.png";